import React from "react";
import { ChipButton, Count, Dot, Group } from "./FilterChipGroup.styles";
import type { FilterChipGroupProps } from "./FilterChipGroup.types";

/** Toggle chips with a status dot and a count; pressing one filters to it. */
export const FilterChipGroup: React.FC<FilterChipGroupProps> = ({ options, value, onChange, ariaLabel, size = "md", selectedLook = "tinted", className }) => (
  <Group className={className} role="group" aria-label={ariaLabel}>
    {options.map((option) => {
      const pressed = option.id === value;
      return (
        <ChipButton key={option.id || "all"} type="button" aria-pressed={pressed} $pressed={pressed} $size={size} $selectedLook={selectedLook} onClick={() => onChange(option.id)}>
          {option.dot ? <Dot $dot={option.dot} aria-hidden="true" data-dot={option.dot} /> : null}
          {option.label}
          {option.count !== null ? <Count $pressed={pressed} $size={size} $selectedLook={selectedLook}>{option.count}</Count> : null}
        </ChipButton>
      );
    })}
  </Group>
);

export default FilterChipGroup;
